
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"},"content":"<g fill=\"none\" fill-rule=\"evenodd\">         <g>             <g transform=\"translate(-882.000000, -829.000000) translate(882.000000, 829.000000)\">                 <rect width=\"16\" height=\"16\" fill=\"#007FBA\" rx=\"2\"/>                 <path stroke=\"#FFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3.698 4.453L12.854 4.31 12.789 8.464\" transform=\"translate(8.276293, 6.386810) rotate(-225.000000) translate(-8.276293, -6.386810)\"/>             </g>         </g>     </g>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)



//////////////////
// WEBPACK FOOTER
// ./assets/posttruck/checkbox-select.svg
// module id = 704
// module chunks = 0